/* Norwegian labels omitted by the storefront apps' language settings. */
(() => {
  if (!/^(nb|nn|no)(-|$)/i.test(document.documentElement.lang)) return;

  const labels = {
    'Close cart': 'Lukk handlekurven',
    'Decrease quantity': 'Reduser antallet',
    'Increase quantity': 'Øk antallet',
    'Product quantity': 'Antall',
    'Select variant': 'Velg variant',
    'Original price': 'Førpris',
    'Sale price': 'Tilbudspris',
    'Savings': 'Du sparer',
    'Price': 'Pris',
    'Discount': 'Rabatt',
    'Discount tag icon': 'Rabatt',
    'Scroll right': 'Bla til høyre',
    'Sort reviews by menu': 'Sorter omtaler',
    'Reviews widget': 'Kundeomtaler',
    'Error icon': 'Rabattkoden kunne ikke brukes',
  };

  const translate = value => {
    if (labels[value]) return labels[value];
    if (value.startsWith('Product Review by ')) return `Produktomtale fra ${value.slice(18)}`;
    const rating = value.match(/^Average rating:\s*([\d.,]+)\s*\/\s*5 star review$/i);
    if (rating) return `Gjennomsnitt: ${rating[1].replace('.', ',')} av 5 stjerner`;
    if (value.startsWith('Remove ')) return `Fjern ${value.slice(7)}`;
    return value;
  };

  let observedCartRoot;
  const observedLooxRoots = new WeakSet();
  function updateLabels() {
    const cartRoot = document.getElementById('upCart')?.shadowRoot;
    if (cartRoot && cartRoot !== observedCartRoot) {
      observer.observe(cartRoot, observerOptions);
      observedCartRoot = cartRoot;
    }
    const cart = (cartRoot || document).getElementById('UpcartPopup');
    if (cart) {
      cart.querySelectorAll('[aria-label], [title]').forEach(element => {
        ['aria-label', 'title'].forEach(attribute => {
          const value = element.getAttribute(attribute);
          if (value && translate(value) !== value) element.setAttribute(attribute, translate(value));
        });
      });
      cart.querySelectorAll('.upcart-internal__visually-hidden, svg title').forEach(element => {
        const value = element.textContent.trim();
        if (translate(value) !== value) element.textContent = translate(value);
      });

      // Upcart otherwise displays only an error icon after an unsuccessful code.
      const form = cart.querySelector('.upcart-public-discount-code__form');
      const error = form?.querySelector('.upcart-public-discount-code__error');
      const feedback = cart.querySelector('#le-upcart-discount-feedback');
      if (error && !feedback) {
        const message = document.createElement('p');
        message.id = 'le-upcart-discount-feedback';
        message.setAttribute('role', 'alert');
        message.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.4;color:inherit';
        message.textContent = 'Rabattkoden kunne ikke brukes. Kontroller koden og vilkårene.';
        form.after(message);
      } else if (!error && feedback) {
        feedback.remove();
      }
    }

    document.querySelectorAll('loox-snippets-widget').forEach(widget => {
      const root = widget.shadowRoot;
      if (!root) return;
      if (!observedLooxRoots.has(root)) {
        observer.observe(root, observerOptions);
        observedLooxRoots.add(root);
      }
      root.querySelectorAll('[aria-label]').forEach(element => {
        const value = element.getAttribute('aria-label');
        if (value && translate(value) !== value) element.setAttribute('aria-label', translate(value));
      });
    });

    document.querySelectorAll('[aria-label], iframe[title]').forEach(element => {
      ['aria-label', 'title'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        if (value && translate(value) !== value) element.setAttribute(attribute, translate(value));
      });
    });
    document.querySelectorAll('.lykkeengler-poll input[placeholder="Skriv inn et navn"]').forEach(element => {
      element.setAttribute('placeholder', 'Skriv ett fornavn');
    });

    document.querySelectorAll('.loox-rating[aria-label], .loox-rating[title]').forEach(element => {
      ['aria-label', 'title'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        const match = value?.match(/^(\d[\d,. ]*) reviews?$/i);
        if (match) element.setAttribute(attribute, `${match[1]} ${match[1] === '1' ? 'omtale' : 'omtaler'}`);
      });
      element.querySelectorAll('svg title').forEach(title => {
        const match = title.textContent.match(/^(\d[\d,. ]*) reviews?$/i);
        if (match) title.textContent = `${match[1]} ${match[1] === '1' ? 'omtale' : 'omtaler'}`;
      });
    });
    document.querySelectorAll('[aria-label="Scroll to reviews"]').forEach(element => {
      element.setAttribute('aria-label', 'Gå til kundeomtalene');
    });
    document.querySelectorAll('iframe[title="On site referral embedded registration form"]').forEach(element => {
      element.setAttribute('title', 'Registrering for Verv en venn');
    });
    document.querySelectorAll('.lykkeengler-poll__description').forEach(element => {
      const original = 'Stem på navnet du liker best, eller foreslå et nytt navn. Vi lager jevnlige nye Lykkeengler og vil plukke fra listen.';
      if (element.textContent === original) {
        element.textContent = 'Stem på navnet du liker best, eller foreslå et nytt navn. Vi lager stadig nye Lykkeengler og henter navneforslag fra listen.';
      }
    });
    document.querySelectorAll('.lykkeengler-poll__option-result').forEach(element => {
      const value = element.textContent;
      const translated = value.replace(/^1 stemmer\b/, '1 stemme').replace(/(\d)%/g, '$1 %');
      if (translated !== value) element.textContent = translated;
    });
  }

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateLabels();
    });
  });
  const observerOptions = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label', 'title'],
  };
  observer.observe(document.body, observerOptions);
  window.addEventListener('load', updateLabels, { once: true });
  updateLabels();
})();
